import { ShoppingCart } from 'lucide-react';
import { useCart, formatAUD } from '@/context/CartContext';

export default function CartFab() {
  const { count, subtotal, openDrawer, drawerOpen } = useCart();

  if (drawerOpen || count === 0) return null;

  return (
    <button
      type="button"
      onClick={openDrawer}
      data-testid="cart-fab"
      aria-label={`Shopping cart · ${count} items`}
      className="group fixed z-40 bottom-6 right-6 sm:bottom-8 sm:right-8 h-16 sm:h-[68px] pl-4 pr-5 rounded-full bg-[var(--mw-primary)] hover:bg-[var(--mw-primary-hover)] text-white shadow-[0_10px_40px_-10px_rgba(155,17,30,0.6)] flex items-center gap-3 transition-all hover:scale-[1.03]"
    >
      <div className="relative">
        <ShoppingCart size={22} className="transition-transform group-hover:-rotate-6" />
        <span
          data-testid="cart-fab-count"
          className="absolute -top-2 -right-2 min-w-[20px] h-[20px] px-1 rounded-full bg-white text-[var(--mw-primary)] text-[10px] font-bold flex items-center justify-center border border-[var(--mw-primary)]"
        >
          {count}
        </span>
      </div>
      <span className="font-display text-base tracking-tight">{formatAUD(subtotal)}</span>
    </button>
  );
}
